import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Çevirileri tertemiz JSON dosyalarından çağırıyoruz
import translationEN from './locales/en.json';
import translationTR from './locales/tr.json';
import translationRU from './locales/ru.json';

const resources = {
    en: { translation: translationEN },
    tr: { translation: translationTR },
    ru: { translation: translationRU }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en", // Varsayılan dil
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;